import { render } from "./StepPrefooterHome.vue?vue&type=template&id=6dbcb7e7&scoped=true&bindings={}"
import script from "./StepPrefooterHome.vue?vue&type=script&lang=ts"
export * from "./StepPrefooterHome.vue?vue&type=script&lang=ts"

import "./StepPrefooterHome.vue?vue&type=style&index=0&id=6dbcb7e7&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-6dbcb7e7"

export default script